"use client";
import * as React from "react";
const SvgEventNoteOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12.44 1.6h-.77V0H10.1v1.6H3.89V0H2.33v1.6h-.77C.7 1.6 0 2.32 0 3.2v11.2c0 .88.7 1.6 1.56 1.6h10.88c.86 0 1.56-.72 1.56-1.6V3.2c0-.88-.7-1.6-1.56-1.6m0 12.8H1.56v-8h10.88zM1.56 4.8V3.2h10.88v1.6zM3.1 8h7.78v1.6H3.1zm0 3.2h5.45v1.6H3.1z" }));
export {
  SvgEventNoteOutlined as default
};
